/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/adm-task'

export default {
    get: params => {
        let customRoute = `${route}?expand=tipoTarea,creadaPor,usuariosAsignados,status_description&search=${params.filter}`
        switch (params.tareaEstado) {
            case "2": customRoute = `${route}?estado=1&expand=tipoTarea,creadaPor,usuariosAsignados,status_description&search=${params.filter}`
                break;
            case "3": customRoute = `${route}?estado=0&expand=tipoTarea,creadaPor,usuariosAsignados,status_description&search=${params.filter}`
                break;
            case "5": customRoute = `${route}?${params.customfilter}&expand=tipoTarea,creadaPor,usuariosAsignados,status_description&search=${params.filter}`//tareas del dia
                break;
            case "6": customRoute = `${route}?${params.customfilter}&expand=tipoTarea,creadaPor,usuariosAsignados,status_description&search=${params.filter}`
                break;
            case "7": customRoute = `${route}?${params.customfilter}&expand=tipoTarea,creadaPor,usuariosAsignados,status_description&search=${params.filter}`//tareas con fecha de cumplimiento en el dia
                break;
            case "8": customRoute = `${route}?${params.customfilter}&expand=tipoTarea,creadaPor,usuariosAsignados,status_description&search=${params.filter}`//tareas cumplidas en el dia
                break;
            default: break;
        }
        return Api().get(customRoute, { params, crossDomain: true })
    },
    getAll: () => Api().get(`${route}?estado=1`, { crossDomain: true }),
    getAllRecords: () => Api().get(`${route}?fields=id,nombre&expand=tipoTarea,creadaPor,usuariosAsignados,status_description`, { crossDomain: true }),
    getHistory: payload => Api().get(`${route}/${payload.id}?expand=status_description,history`, { crossDomain: true }),
    post: payload => Api().post(`${route}?expand=tipoTarea,creadaPor,usuariosAsignados,status_description`, payload),
    put: payload => Api().put(`${route}/${payload.id}?expand=tipoTarea,creadaPor,usuariosAsignados,status_description`, payload),
    toogle_status: payload => Api().put(`/adm-task-user/${payload.id}`),
    delete: payload => Api().delete(`${route}/${payload.id}?expand=tipoTarea,creadaPor,usuariosAsignados,status_description`)
}
